<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired, validRequired_copy } from '@/common/elementValid.js';
import skyUploadimgSelect from './components/sky-uploadimg-select.vue';
import welcomePageSer from '@/backend/services/welcomePage/welcomePageSer.js';
import { buildTreeData } from '@/common/util.js';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { info, partList } = attributes;
	let { title, bannerPicList, showFlag, systemTypeList } = info;
	partList = buildTreeData(partList, {
		id: 'id',
		pid: 'parentId',
		level: 'type',
		root: 1,
	});
	if (bannerPicList)
		bannerPicList.forEach(item => {
			let { jumpType, twoContent, picUrl } = item;
			if (jumpType === 1) {
				item.oneContent = twoContent;
				item.twoContent = '';
			}
			item.url = picUrl;
		});
	if (!systemTypeList) systemTypeList = [];
	return {
		title: {
			label: '标题：',
			formType: 'sky-input',
			value: title || '',
			rules: [validRequired('请填写标题')],
		},
		bannerPicList: {
			label: '图片：',
			formType: skyUploadimgSelect,
			accept: 'image/jpeg, image/png',
			options: partList,
			props: { value: 'routeCode', label: 'name', emitPath: false },
			value: bannerPicList || [],
			// value: [],
		},
		// defaultFlag: {
		// 	label: '是否默认：',
		// 	formType: 'sky-radio',
		// 	options: [
		// 		{
		// 			label: '是',
		// 			value: 1,
		// 		},
		// 		{
		// 			label: '否',
		// 			value: 0,
		// 		},
		// 	],
		// 	value: defaultFlag || 0,
		// },
		showFlag: {
			label: '是否显示：',
			formType: 'sky-radio',
			options: [
				{
					label: '是',
					value: 1,
				},
				{
					label: '否',
					value: 0,
				},
			],
			value: showFlag || 0,
			rules: [validRequired_copy('请选择是否显示')],
		},
		systemTypeList: {
			label: '客户端：',
			formType: 'sky-radio',
			options: [
				{
					label: 'WEB端',
					value: '1',
				},
				{
					label: 'APP端',
					value: '2',
				},
			],
			value: systemTypeList[0] || '',
			rules: [validRequired_copy('请选择客户端')],
			visable(vm) {
				return vm.formData.fields.showFlag.value === 1;
			},
		},
	};
}

async function submit(data) {
	try {
		let { attributes } = this;
		let { info } = attributes;
		data.systemTypeList = data.systemTypeList ? [data.systemTypeList] : [];
		data.bannerPicList.forEach(item => {
			let { jumpType, oneContent, url } = item;
			if (jumpType === 1) item.twoContent = oneContent;
			item.oneContent = '';
			item.picUrl = url;
		});
		data = {
			...info,
			...data,
		};
		data.defaultFlag = info.defaultFlag || 0;
		await welcomePageSer.welcomeAddOrUpdate(data);
		this.$emit('confirm');
	} catch (error) {
		this.$message.error('操作失败');
	}
}

function cancel(self) {
	self.$emit('cancel');
}

async function onShowLoad(props) {
	// 获取权限列表
	let res = await welcomePageSer.menupermissionsPart({
		name: '',
	});
	return {
		info: props || {},
		partList: res.data,
	};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		labelWidth: '130px',
		subButton: '确认',
	}
);

export default formDialogCreate({
	name: 'addWelcomePageForm',
	onShowLoad,
	componentForm,
});
</script>

<style scoped lang="scss"></style>
